import { css } from '@emotion/css';

export const closeIcon = css`
  top: 15px;
  right: 15px;
`;
